import { type ModuleResult } from '@pixacare/forms';
import { FileWithModuleId } from '../models/file-with-module-id';
import { FORM_OUTPUTS_PICTURE_KEY } from '../models/form-outputs';

export const buildModuleTargetId = (moduleId: string, targetId: string): string => `${moduleId}.${targetId}`;

export const extractModulePictures = (moduleId: string, targetId: string, result: ModuleResult): FileWithModuleId[] => {
  const pictures = result[`${moduleId}.${FORM_OUTPUTS_PICTURE_KEY}`] as File[] | undefined;
  if (!pictures?.length) {
    return [];
  }
  const moduleTargetId = buildModuleTargetId(moduleId, targetId);
  return pictures.map((file) => {
    const tagged = file as FileWithModuleId;
    tagged.moduleId = moduleTargetId;
    return tagged;
  });
};

export const removeModulePictures = (
  files: readonly FileWithModuleId[] | undefined,
  moduleId: string,
  targetId: string,
): FileWithModuleId[] => {
  const moduleTargetId = buildModuleTargetId(moduleId, targetId);
  return (files ?? []).filter((file) => file.moduleId !== moduleTargetId);
};
